import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Ticket, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Events() {
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  const buy = async (event, tier) => {
    if (!user) { toast.error("Sign in to buy tickets"); return; }
    setBusy(`${event.id}-${tier}`);
    try { const { data } = await api.post("/tickets/checkout", { event_id: event.id, tier, origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not start checkout"); setBusy(""); }
  };

  return (
    <div className="section py-12 sm:py-16" data-testid="events-page">
      <p className="kicker mb-2">The Road to the Crown</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">Events & Tickets</h1>
      <p className="mt-3 max-w-2xl text-amber-100/60">From the preliminary gala to the grand coronation — secure your seat at the continental celebration.</p>

      <div className="mt-10 space-y-4">
        {events.map((e, i) => (
          <div key={e.id} className="card-lux flex flex-col gap-4 p-6 lg:flex-row lg:items-center" data-testid={`event-${i}`}>
            <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-lg gold-bg text-obsidian">
              <span className="font-mono text-xl leading-none">{new Date(e.date).getDate()}</span>
              <span className="text-[0.6rem] uppercase">{new Date(e.date).toLocaleDateString(undefined, { month: "short" })}</span>
            </div>
            <div className="flex-1">
              <span className="kicker">{e.type}</span>
              <h3 className="mt-1 font-serif text-2xl text-amber-50">{e.name}</h3>
              <p className="mt-1 flex items-center gap-2 text-sm text-amber-100/60"><MapPin className="h-4 w-4 text-gold/70" /> {e.venue}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => buy(e, "general")} disabled={busy === `${e.id}-general`} data-testid={`ticket-general-${e.id}`} className="btn-ghost-gold inline-flex items-center gap-2 text-xs">
                {busy === `${e.id}-general` ? <Loader2 className="h-4 w-4 animate-spin" /> : <Ticket className="h-4 w-4" />} General $25
              </button>
              <button onClick={() => buy(e, "vip")} disabled={busy === `${e.id}-vip`} data-testid={`ticket-vip-${e.id}`} className="btn-gold inline-flex items-center gap-2 text-xs">
                {busy === `${e.id}-vip` ? <Loader2 className="h-4 w-4 animate-spin" /> : <Ticket className="h-4 w-4" />} VIP $120
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
